import { Modal, ModalProps } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { ExternalInvoicesSyncModalContextProvider } from './contexts/externalInvoicesSyncModalContext'
import { ModalBody } from './elements/ModalBody'
import { ModalFooter } from './elements/ModalFooter'

export const ExternalInvoicesSyncModal = (modalProps: ModalProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <ExternalInvoicesSyncModalContextProvider modalId={modalProps.id}>
      <Modal size="s" {...modalProps}>
        <Modal.Header title={t('external_invoices_sync_modal.header')} />
        <Modal.Body>
          <ModalBody />
        </Modal.Body>
        <Modal.Footer>
          <ModalFooter />
        </Modal.Footer>
      </Modal>
    </ExternalInvoicesSyncModalContextProvider>
  )
}
